export const casinos = [
  {
    id: "888",
    name: "888 Casino",
    logo: "/logos/888.dk.jpg",
    url: "https://www.888.dk/",
    rating: 9.4,
    featured: true,
    description:
      "Et af verdens mest kendte casinobrands med en lang og veldokumenteret historik. 888 Casino tilbyder et bredt udvalg af spillemaskiner, bordspil og live casino – alt sammen med dansk licens og stærk kundesupport.",
    tags: ["Dansk licens", "Live Casino", "Stærk spiludbyder", "Mobilvenlighed", "24/7 support"],
    highlight: "Internationalt anerkendt brand med dansk licens",
  },
  {
    id: "mrgreen",
    name: "Mr Green",
    logo: "/logos/mrgreen.dk.png",
    url: "https://www.mrgreen.dk/",
    rating: 9.2,
    featured: true,
    description:
      "Mr Green er synonymt med ansvarligt spil og en curated spiloplevelse. Med en ren og indbydende brugerflade og et fremragende udvalg af spil henvender Mr Green sig til den modne og bevidste spiller.",
    tags: ["Ansvarligt spil", "Green Gaming", "Prisvindende design", "Live dealer", "Spillemyndigheden"],
    highlight: "Prisvindende casino med fokus på ansvarligt spil",
  },
  {
    id: "unibet",
    name: "Unibet",
    logo: "/logos/unibet.png",
    url: "https://www.unibet.dk/",
    rating: 9.1,
    featured: false,
    description:
      "Unibet er en af Skandinaviens største og mest betroede spiludbydere. Med et komplet tilbud fra sport til casino og poker er Unibet et naturligt valg for danske spillere.",
    tags: ["Sport & Casino", "Skandinavisk brand", "Populær i Danmark", "Hurtige udbetalinger"],
    highlight: "Skandinaviens foretrukne all-round spiludbyder",
  },
  {
    id: "danskespil",
    name: "Danske Spil",
    logo: "/logos/danskespil.dk.png",
    url: "https://www.danskespil.dk/",
    rating: 8.8,
    featured: false,
    description:
      "Danske Spil er det statsejede spilselskab med rødder i den danske gaming-kultur. En troværdig og velkendt platform for klassiske casinospil, lotto og sport.",
    tags: ["Statsautoriseret", "Dansk brand", "Bredt spilsortiment", "Tillid & tryghed"],
    highlight: "Danmarks nationalplatform for spil",
  },
  {
    id: "betsson",
    name: "Betsson",
    logo: "/logos/betsson.dk.png",
    url: "https://www.betsson.dk/",
    rating: 8.7,
    featured: false,
    description:
      "Betsson kombinerer årtiers erfaring med en moderne og intuitiv platform. Med tusindvis af spillemaskiner og et stærkt live casino er Betsson et solidt valg for erfarne spillere.",
    tags: ["Stort spiludvalg", "Hurtige udbetalinger", "Live Casino", "Erfaren udbyder"],
    highlight: "Nordisk kraft med et enormt spiludvalg",
  },
  {
    id: "tombola",
    name: "Tombola",
    logo: "/logos/tombola.dk.png",
    url: "https://www.tombola.dk/",
    rating: 8.5,
    featured: false,
    description:
      "Tombola er Europas største dedikerede bingoudbyder og tilbyder en unik og social spiloplevelse. Med et venligt fællesskab og sjove spil skiller Tombola sig positivt ud.",
    tags: ["Bingo specialist", "Socialt spil", "Eksklusiv platform", "Familievenlig stemning"],
    highlight: "Europas ledende bingoudbyder – unik og social",
  },
  {
    id: "betfair",
    name: "Betfair",
    logo: "/logos/betfair.dk.png",
    url: "https://betfair.dk/",
    rating: 8.6,
    featured: false,
    description:
      "Betfair er verdensberømt for sin børsmodel og tilbyder sportsbetting i en klasse for sig. Casino-afsnittet rummer klassiske og live spil i høj kvalitet.",
    tags: ["Betting Exchange", "Internationalt brand", "Casino & Sport", "Unik betting-model"],
    highlight: "Verdensklasse i sportsbetting og casino",
  },
  {
    id: "bet25",
    name: "Bet25",
    logo: "/logos/bet25.jpg",
    url: "https://bet25.dk/",
    rating: 8.3,
    featured: false,
    description:
      "Bet25 er et dansk produceret spilsite med stærkt fokus på sport og casino. Platformen udmærker sig ved dansk sproglig tilgang og tilpassede kampagner til det danske marked.",
    tags: ["Dansk fokus", "Sport & Casino", "Lokale tilbud", "Brugervenlighed"],
    highlight: "Danskproduceret med stærk lokal forankring",
  },
  {
    id: "campobet",
    name: "CampoBet",
    logo: "/logos/campobet.dk.webp",
    url: "https://campobet.dk/",
    rating: 8.2,
    featured: false,
    description:
      "CampoBet tilbyder en spændende og moderne spiloplevelse med et bredt katalog af spillemaskiner og velorganiserede sportsmarkeder. En platform med godt tempo og frisk design.",
    tags: ["Moderne design", "Bredt sortiment", "Sport & Slots", "Hurtig platform"],
    highlight: "Frisk og moderne casino med bred vifte",
  },
  {
    id: "tivolicasino",
    name: "Tivoli Casino",
    logo: "/logos/tivolicasino.png",
    url: "https://tivolicasino.dk/",
    rating: 8.4,
    featured: false,
    description:
      "Tivoli Casino bærer det ikoniske danske navn med stolthed og tilbyder klassiske casinospil i en stemningsfuld og indbydende atmosfære. En platform med nationalt tilhørsforhold.",
    tags: ["Ikonisk dansk navn", "Klassisk casino", "Licenseret", "Stemningsfuldt"],
    highlight: "Casino med ægte dansk sjæl og karakter",
  },
];

export const trustOrgs = [
  {
    id: "spillemyndigheden",
    name: "Spillemyndigheden",
    logo: "/logos/Spillemyndigheden.jpg",
    url: "https://www.spillemyndigheden.dk/",
    description: "Den danske spillemyndighed regulerer og overvåger alle licenserede spiludbydere i Danmark.",
  },
  {
    id: "rofus",
    name: "ROFUS",
    logo: "/logos/rofus.jpg",
    url: "https://www.rofus.nu/",
    description: "Register Over Frivilligt Udelukkede Spillere – dit redskab til selvudelukkelse fra alle danske spilsider.",
  },
  {
    id: "stopspillet",
    name: "StopSpillet",
    logo: "/logos/StopSpillet.jpg",
    url: "https://www.stopspillet.dk/",
    description: "Hjælp og rådgivning til spillere og pårørende – Danmarks nationale hjælpelinje for ludomani.",
  },
];
